import { render, staticRenderFns } from "./CprClaims.vue?vue&type=template&id=c1b35d0a"
import script from "./CprClaims.vue?vue&type=script&lang=js"
export * from "./CprClaims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports